export default "__VITE_ASSET__DHkOLqGO__"